import React from 'react'
import TranslationsEditor from './TranslationsEditor.jsx'

export default function SystemTranslationsEditor( props ) {
  const { blueprint, ...rest } = props

  return <TranslationsEditor {...rest} />
}
